import { Box } from '@mui/material'
import { RawTodoResult } from './PatientToDoService'
import InlineEditableField from './InlineEditableField'

interface Props {
  patientTodo: RawTodoResult
  isClosed: boolean
  setIsTodoNoteUpdating: (value: boolean) => void
}

const ToDoNotes = (props: Props) => {
  if (props.patientTodo.content_type !== 'case') {
    return null
  }

  const contentObject = props.patientTodo.content_object as
    { id: number; notes?: string | null } | undefined

  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '& .MuiFormControl-root.MuiTextField-root': {
          marginLeft: 0,
        },
      }}
    >
      {contentObject?.notes ? (
        <InlineEditableField
          defaultValue={contentObject?.notes}
          selectedCase={contentObject.id}
          valueToBeUpdated={'notes'}
          placeholder={'+ Add notes'}
          isClosed={props.isClosed}
          setEditingCase={props.setIsTodoNoteUpdating}
        />
      ) : contentObject ? (
        <InlineEditableField
          selectedCase={contentObject?.id}
          valueToBeUpdated={'notes'}
          placeholder={'+ Add notes'}
          isClosed={props.isClosed}
          setEditingCase={props.setIsTodoNoteUpdating}
        />
      ) : null}
    </Box>
  )
}

export default ToDoNotes
